import { requestHandler } from "..";
import { axiosInstance } from "../../../../utils/axios";

export const handleListRequest = async ({ method, url, token, data }) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const requestOptions = {
    method,
    url,
    ...(method !== "get" && { data }),
    ...config,
  };

  try {
    const response = await axiosInstance(requestOptions);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error(error);
    let errorMessage = "Something went wrong";
    if (error.response) {
      errorMessage = error.response.data;
    } else if (error.request) {
      errorMessage = "No response received";
    } else {
      errorMessage = error.message || "Error setting up the request";
    }
    return {
      success: false,
      message: errorMessage,
    };
  }
};

export const getUserList = (token, user_id, store_id, list_id) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/store/${store_id}/lists/${list_id}`,
    token,
  });
};
export const getPaymentDetail = (token, user_id, store_id, list_id) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/store/${store_id}/lists/${list_id}/paymentIntent`,
    token,
  });
};
export const placeOrder = (token, user_id, store_id, list_id, data) => {
  return requestHandler({
    method: "POST",
    url: `users/${user_id}/store/${store_id}/lists/${list_id}/order`,
    token,
    data,
  });
};
export const toggleListLock = (token, user_id, store_id, list_id, data) => {
  return requestHandler({
    method: "PUT",
    url: `users/${user_id}/store/${store_id}/lists/${list_id}/lock`,
    token,
    data,
  });
};
export const shareList = (token, user_id, store_id, list_id, data) => {
  return requestHandler({
    method: "POST",
    url: `users/${user_id}/store/${store_id}/lists/${list_id}/share`,
    token,
    data,
  });
};
export const unShareList = (token, user_id, store_id, list_id) => {
  return requestHandler({
    method: "DELETE",
    url: `users/${user_id}/store/${store_id}/lists/${list_id}/unshare`,
    token,
  });
};

export const addList = (token, user_id, data) => {
  return requestHandler({
    method: "POST",
    url: `users/${user_id}/lists`,
    token,
    data,
  });
};
export const addItemToList = (token, user_id, list_id, item_ean13, data) => {
  return requestHandler({
    method: "POST",
    url: `users/${user_id}/lists/${list_id}/items/${item_ean13}`,
    token,
    data,
  });
};
